export const BankIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.0002 7.83342H2.00016C1.36016 7.83342 0.833496 7.30676 0.833496 6.66676V4.45342C0.833496 4.00008 1.14681 3.54009 1.56681 3.37342L7.56681 0.973438C7.82015 0.873437 8.18018 0.873437 8.43351 0.973438L14.4335 3.37342C14.8535 3.54009 15.1668 4.00675 15.1668 4.45342V6.66676C15.1668 7.30676 14.6402 7.83342 14.0002 7.83342ZM8.00016 1.89344C7.9735 1.89344 7.94685 1.89341 7.93351 1.90007L1.94014 4.3001C1.90014 4.3201 1.8335 4.40675 1.8335 4.45342V6.66676C1.8335 6.76009 1.90683 6.83342 2.00016 6.83342H14.0002C14.0935 6.83342 14.1668 6.76009 14.1668 6.66676V4.45342C14.1668 4.40675 14.1068 4.3201 14.0602 4.3001L8.06018 1.90007C8.04685 1.89341 8.02683 1.89344 8.00016 1.89344Z"
      fill={strokeColor}
    />
    <path
      d="M14.6668 15.1667H1.3335C1.06016 15.1667 0.833496 14.94 0.833496 14.6667V12.6667C0.833496 12.0267 1.36016 11.5 2.00016 11.5H14.0002C14.6402 11.5 15.1668 12.0267 15.1668 12.6667V14.6667C15.1668 14.94 14.9402 15.1667 14.6668 15.1667ZM1.8335 14.1667H14.1668V12.6667C14.1668 12.5733 14.0935 12.5 14.0002 12.5H2.00016C1.90683 12.5 1.8335 12.5733 1.8335 12.6667V14.1667Z"
      fill={strokeColor}
    />
    <path
      d="M2.6665 12.5007C2.39317 12.5007 2.1665 12.274 2.1665 12.0007V7.33398C2.1665 7.06065 2.39317 6.83398 2.6665 6.83398C2.93984 6.83398 3.1665 7.06065 3.1665 7.33398V12.0007C3.1665 12.274 2.93984 12.5007 2.6665 12.5007Z"
      fill={strokeColor}
    />
    <path
      d="M13.3335 12.5007C13.0602 12.5007 12.8335 12.274 12.8335 12.0007V7.33398C12.8335 7.06065 13.0602 6.83398 13.3335 6.83398C13.6068 6.83398 13.8335 7.06065 13.8335 7.33398V12.0007C13.8335 12.274 13.6068 12.5007 13.3335 12.5007Z"
      fill={strokeColor}
    />
    <path
      d="M15.3332 15.166H0.666504C0.393171 15.166 0.166504 14.9393 0.166504 14.666C0.166504 14.3927 0.393171 14.166 0.666504 14.166H15.3332C15.6065 14.166 15.8332 14.3927 15.8332 14.666C15.8332 14.9393 15.6065 15.166 15.3332 15.166Z"
      fill={strokeColor}
    />
    <path
      d="M8 6.16602C7.17333 6.16602 6.5 5.49268 6.5 4.66602C6.5 3.83935 7.17333 3.16602 8 3.16602C8.82667 3.16602 9.5 3.83935 9.5 4.66602C9.5 5.49268 8.82667 6.16602 8 6.16602ZM8 4.16602C7.72667 4.16602 7.5 4.39268 7.5 4.66602C7.5 4.93935 7.72667 5.16602 8 5.16602C8.27333 5.16602 8.5 4.93935 8.5 4.66602C8.5 4.39268 8.27333 4.16602 8 4.16602Z"
      fill={strokeColor}
    />
  </svg>
);
